import React from 'react';

import { IconCalculator } from '@/app/components/icons/business-payments/icon-calculator';
import { IconLocationOn } from '@/app/components/icons/maps/icon-location-on';
import { IconMap } from '@/app/components/icons/maps/icon-map';
import { IconSteering } from '@/app/components/icons/transportation/icon-steering';
import { IconCompareArrows } from '@/app/components/icons/ui-actions/icon-compare-arrows';
import type { BuyingToolItemProps } from '@/app/components/layouts/footer/buying-tool';
import { FooterNavColumn } from '@/app/components/layouts/footer/nav';
import { MENU_LINK_CV } from '@/app/contents/top-navigation';
import { NavigationMenuLabel } from '@/app/lcv/constants/top-navigation';
import { MENU_LCV_SOCIAL_GROUP } from '@/app/lcv/contents/social-media';
import {
  ABOUTUS_MENUS,
  BENEFIT_MENUS,
  OFFER_MENUS,
  PARTNERS_MENUS,
  SERVICE_MENUS,
  SHARE_MENUS,
} from '@/app/lcv/contents/top-navigation';
import {
  MUX_RS_DATA as BLUEPOWER_MUX_RS_DATA,
  MUX_ULTIMATE_DATA as BLUEPOWER_MUX_ULTIMATE_DATA,
  PICKUP_2DOOR_DATA as BLUEPOWER_PICKUP_2DOOR_DATA,
  PICKUP_4DOOR_DATA as BLUEPOWER_PICKUP_4DOOR_DATA,
  SPARK_DATA as BLUEPOWER_SPARK_DATA,
  V_CROSS_DATA as BLUEPOWER_V_CROSS_DATA,
  X_SERIES_DATA as BLUEPOWER_X_SERIES_DATA,
} from '@/contents/lcv/product/bluepower/shared/lineup';
import {
  MUX_RS_DATA,
  MUX_ULTIMATE_DATA,
  PICKUP_2DOOR_DATA,
  PICKUP_4DOOR_DATA,
  SPARK_DATA,
  V_CROSS_DATA,
} from '@/contents/lcv/product/maxforce/shared/lineup';

export const FOOTER_BUYING_TOOLS: BuyingToolItemProps[] = [
  {
    icon: <IconSteering />,
    href: '/register',
    title: 'สนใจรถ / <span>ทดลองขับ</span>',
    desc: 'ลงทะเบียนสนใจรถอีซูซุ <span>หรือทดลองขับ</span>',
  },
  {
    icon: <IconCompareArrows />,
    href: '/compare',
    title: 'เปรียบเทียบ<span>รุ่นรถ</span>',
    desc: 'เปรียบเทียบข้อมูลรถทุกรุ่น<span>โดยละเอียด</span>',
  },
  {
    icon: <IconCalculator />,
    href: '/calculator',
    title: 'คำนวณ<span>ค่างวด</span>',
    desc: 'คำนวณค่าใช้จ่ายในการออกรถ',
  },
  {
    icon: <IconLocationOn />,
    href: '/dealer',
    title: 'ค้นหาโชว์รูม / <span>ศูนย์บริการ</span>',
    desc: 'ค้นหาโชว์รูมอีซูซุใกล้บ้านคุณ<span>ได้ที่นี่</span>',
  },
  {
    icon: <IconMap />,
    href: '/download-brochure',
    title: 'ดาวน์โหลด<span>โบรชัวร์</span>',
    desc: 'ดาวน์โหลดโบรชัวร์ของรถอีซูซุ<span>ทุกรุ่น</span>',
  },
];

export const FOOTER_NAV: FooterNavColumn[] = [
  [
    {
      title: {
        label: 'รุ่นเครื่องยนต์ <span>MAXFORCE</span>',
      },
      menu: [
        {
          name: 'รถปิกอัพ',
          links: [
            {
              label: V_CROSS_DATA.label,
              href: V_CROSS_DATA.url,
            },
            {
              label: PICKUP_4DOOR_DATA.label,
              href: PICKUP_4DOOR_DATA.url,
            },
            {
              label: PICKUP_2DOOR_DATA.label,
              href: PICKUP_2DOOR_DATA.url,
            },
            {
              label: SPARK_DATA.label,
              href: SPARK_DATA.url,
            },
          ],
        },
        {
          name: 'รถอเนกประสงค์',
          links: [
            {
              label: MUX_RS_DATA.label,
              href: MUX_RS_DATA.url,
            },
            {
              label: MUX_ULTIMATE_DATA.label,
              href: MUX_ULTIMATE_DATA.url,
            },
          ],
        },
      ],
    },
    {
      title: {
        label: 'รุ่นเครื่องยนต์ BLUE POWER',
      },
      isAccordion: true,
      menu: [
        {
          name: 'รถปิกอัพ',
          links: [
            {
              label: BLUEPOWER_V_CROSS_DATA.label,
              href: BLUEPOWER_V_CROSS_DATA.url,
            },
            {
              label: BLUEPOWER_PICKUP_4DOOR_DATA.label,
              href: BLUEPOWER_PICKUP_4DOOR_DATA.url,
            },
            {
              label: BLUEPOWER_PICKUP_2DOOR_DATA.label,
              href: BLUEPOWER_PICKUP_2DOOR_DATA.url,
            },
            {
              label: BLUEPOWER_SPARK_DATA.label,
              href: BLUEPOWER_SPARK_DATA.url,
            },
            {
              label: BLUEPOWER_X_SERIES_DATA.label,
              href: BLUEPOWER_X_SERIES_DATA.url,
            },
          ],
        },
        {
          name: 'รถอเนกประสงค์',
          links: [
            {
              label: BLUEPOWER_MUX_RS_DATA.label,
              href: BLUEPOWER_MUX_RS_DATA.url,
            },
            {
              label: BLUEPOWER_MUX_ULTIMATE_DATA.label,
              href: BLUEPOWER_MUX_ULTIMATE_DATA.url,
            },
          ],
        },
      ],
    },
    {
      title: {
        label: 'รถบรรทุกอีซูซุ',
        href: MENU_LINK_CV.href,
        target: MENU_LINK_CV.target,
      },
    },
  ],
  [
    {
      title: {
        label: NavigationMenuLabel.offer,
      },
      menu: [
        {
          links: OFFER_MENUS,
        },
      ],
    },
    {
      title: {
        label: NavigationMenuLabel.service,
      },
      menu: [
        {
          links: SERVICE_MENUS,
        },
      ],
    },
    {
      title: {
        label: NavigationMenuLabel.benefit,
      },
      menu: [
        {
          links: BENEFIT_MENUS,
        },
      ],
    },
  ],
  [
    {
      title: {
        label: NavigationMenuLabel.share,
      },
      menu: [
        {
          links: SHARE_MENUS,
        },
      ],
    },
    {
      title: {
        label: NavigationMenuLabel.serviceOther,
      },
      menu: [
        {
          links: PARTNERS_MENUS,
        },
      ],
    },
  ],
  [
    {
      title: {
        label: NavigationMenuLabel.aboutus,
      },
      menu: [
        {
          links: ABOUTUS_MENUS,
        },
      ],
    },
    {
      title: {
        label: NavigationMenuLabel.online,
      },
      menu: [
        {
          links: MENU_LCV_SOCIAL_GROUP,
        },
      ],
    },
  ],
];
